<template>
  <div class="select_dialog_embed">
    <div class="order_list_embed_msg_embed" v-if="showType !== 'intelligentAddressEntry'">
      <div class="select_dialog_embed_box">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}</p>
        </div>

        <!--弹出框信息-->
        <!--添加货品里面的删除-->
        <div v-if="showType === 'sellerRemarksDel'" class="select_dialog_embed_box_content">
          <p class="mt30 mb30 ml40">请确定是否删除选择的明细？</p>
        </div>

        <!--添加货品里面的提交-->
        <div v-if="showType === 'addGoods'" class="select_dialog_embed_box_content">
          <p class="mt30 mb10 ml40">请核对是否要添加以下货品到选中的订单？</p>
          <p class="mb10 ml40 no_newline" v-for="(item, index) in orderMsg.OrderGoodsList" :key="index">
            {{item.GoodsId}}&nbsp;&nbsp;{{item.ColorAlias}}&nbsp;&nbsp;{{item.Size}}&nbsp;&nbsp;{{item.Qty}}
          </p>
          <!--<p class="mb10 ml40">10000101  蓝色  44.5  3</p>-->
        </div>

        <!--添加货品里面的SKU校验-->
        <div v-if="showType === 'addGoodsValidatuionFailed'" class="select_dialog_embed_box_content validatuion_failed">
          <div class="mt10 mr10 mb10 ml10">
            <table class="table">
              <colgroup><col style="width: 100%"></colgroup>
              <thead>
              <tr>
                <th>行号</th>
                <th>错误</th>
              </tr>
              </thead>
            </table>
            <table class="table">
              <colgroup><col style="width: 100%"></colgroup>
              <tbody>
              <tr v-for="(item, index) in orderMsg" :key="index">
                <td>{{item.RowNo}}</td>
                <td>{{item.ErrorContent}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!--改货-SKU校验失败-->
        <div v-if="showType === 'validatuionFailed'" class="select_dialog_embed_box_content validatuion_failed">
          <div class="mt10 mr10 mb10 ml10">
            <table class="table">
              <colgroup><col style="width: 100%"></colgroup>
              <thead>
              <tr>
                <th>行号</th>
                <th>错误</th>
              </tr>
              </thead>
            </table>
            <table class="table">
              <colgroup><col style="width: 100%"></colgroup>
              <tbody>
              <tr v-for="(item, index) in orderMsg" :key="index">
                <td>{{item.Line}}</td>
                <td>{{item.Msg}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!--改货—库存不足数据-->
        <div v-if="showType === 'insufficientInventory'" class="select_dialog_embed_box_content insufficient_inventory">
          <p class="mt10 mr10 ml10">渠道库存不足，请重新编辑订单明细或更改配货渠道后再进行改货！</p>
          <div class="mt10 mr10 mb10 ml10">
            <table class="table">
              <colgroup><col style="width: 100%"></colgroup>
              <thead>
              <tr>
                <th>货号</th>
                <th>颜色</th>
                <th>尺码</th>
                <th>数量</th>
                <th>库存</th>
              </tr>
              </thead>
            </table>
            <table class="table">
              <colgroup><col style="width: 100%"></colgroup>
              <tbody>
              <tr v-for="(item, index) in orderMsg" :key="index">
                <td>{{item.GoodsId}}</td>
                <td>{{item.ColorAlias}}</td>
                <td>{{item.Size}}</td>
                <td>{{item.Qty}}</td>
                <td>{{item.Stock}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom">
          <button class="btn_normal" v-if="showType !== 'orderDetail'
          && showType !== 'validatuionFailed'
          && showType !== 'insufficientInventory'
          && showType !== 'addGoodsValidatuionFailed'" @click="submitBtn()">确定</button>
          <button class="btn_cancel" @click="cancelBtn(false)">关闭</button>
        </div>
      </div>
    </div>

    <!--智能地址录入-->
    <!--加蒙版关闭当前页面而已-->
    <div v-if="showType === 'intelligentAddressEntry'" class="pa" @click="closePage()" style="top: 0; left: 0; width: 100%; height: 100%; z-index: 0"></div>
    <div class="order_list_embed_msg_embed intelligent_address_entry" v-if="showType === 'intelligentAddressEntry'">
      <div class="select_dialog_embed_box_content">
        <div>
          <textarea class="w_percent99" v-model="addressObj.addressContent" @keydown="listenCode()" placeholder="可以从淘宝等平台复制物流信息到这里，提高下单效率，格式要求（姓名,手机,地址,邮编）例如：张XX,13888888888,浙江省 金华市 婺城区 永康街697号东侧二楼,321000"></textarea>
        </div>
        <div class="text_center mb20">
          <button class="btn btn_normal" @click="submitBtn()">确定</button>
        </div>
      </div>
    </div>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :is-suc="isSuc"
                :txt="txtMsg" @closebtn="closeMsgDialog"></msg-dialog>
  </div>
</template>

<script>
  import MsgDialog from '../../public-component/msg-dialog';

    export default {
        name: 'order-list-embed-msg-embed',
      /**
       *  title：  头部名
       *  showType:
       *  orderMsg: 订单信息
       * */
      props: ['title', 'showType', 'orderMsg'],
      components: {MsgDialog},
      data() {
        return {
          addressObj: {
            provinceName: null, // 省名
            provinceId: null, // 选择到省id
            cityName: null, // 市名
            cityId: null, // 选择到市id
            areaName: null, // 区名
            areaId: null, // 选择到区（县）id
            addressName: null, // 地方详细名
            name: null, // 收货人
            phone: null, // 联系方式
            postCode: null, // 邮编
            addressContent: null // 文本框的内容
          }, // 地址对象
          provincesList: [], // 省份下拉
          selectProvince: null, // 选择的省份
          cityList: [], // 城市下拉
          selectCity: null, // 选择的城市
          areaList: [], // 区下拉
          selectArea: null, // 选择的区
          isMsg: false, // 信息框显示
          isSuc: false, // 是否成功
          txtMsg: '信息框内容' // 信息框内容
        }
      },
      methods: {
        /** 中国大陆加港澳台手机正则验证
         * 中国大陆：开头1 3-8号段，后边跟9位数字
         * 台湾：09开头后面跟8位数字
         * 香港：9或6开头后面跟7位数字
         * 澳门：66或68开头后面跟5位数字
         * */
        phoneReg(num) {
          const reg = /^[1][0-9]\d{9}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/;
          return reg.test(num);
        },

        // 固话
        telephone(num) {
          const reg = /0\d{2,3}-\d{7,8}/;
          return reg.test(num);
        },

        // 特殊省份的地址
        specialProvince(address, addressNmae) {
          if (address[0].indexOf(addressNmae) !== -1 || address[0].indexOf(addressNmae + '市') !== -1 || address[1].indexOf(addressNmae) !== -1 || address[1].indexOf(addressNmae + '市') !== -1) {
            this.addressObj.provinceName = addressNmae;
            this.addressObj.cityName = addressNmae + '市';
            if (address.length > 2) {
              if (address[0] === '台湾' || address[0] === '台湾市') {
                this.addressObj.cityName = address[1];
              }
              this.addressObj.areaName = address[2];
              this.addressObj.addressName = this.addressObj.addressContent.substring(this.addressObj.addressContent.indexOf(this.addressObj.areaName) + this.addressObj.areaName.length, this.addressObj.addressContent.indexOf(' '));
              this.cancelBtn(true);
            } else if (address.length === 2 && address[1] !== addressNmae && address[1] !== (addressNmae + '市')) {
              this.addressObj.areaName = address[1];
              this.addressObj.addressName = this.addressObj.addressContent.substring(this.addressObj.addressContent.indexOf(this.addressObj.areaName) + this.addressObj.areaName.length, this.addressObj.addressContent.indexOf(' '));
              this.cancelBtn(true);
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = '请填写正确的地址';
            }
          }
        },

        // 获取省份下拉框
        getAllProvinceList() {
          this.$axios.get(this.Global.getAllProvinceList).then((res) => {
            if (!res.data.errorMsg.length) {
              this.provincesList = res.data.resData;
            }
          });
        },

        // 详细地址解析
        addressResolution(content) {
          if (content) {
            let provinceArr = [];
            let cityArr = [];
            let areaArr = [];
            const provinceReg = new RegExp(content.split(' ')[0]);
            const cityReg = new RegExp(content.split(' ')[1]);
            const areaReg = new RegExp(content.split(' ')[2]);
            for (let i = 0; i < this.provincesList.length; i++) {
              if (this.provincesList[i].text.match(provinceReg)) {
                provinceArr.push(this.provincesList[i]);
              }
            }
            if (provinceArr.length !== 1) {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = '请填写完整的省份';
              return;
            }
            this.$axios.get(this.Global.getAllCityList(provinceArr[0].id)).then((res) => {
              if (!res.data.errorMsg.length) {
                this.cityList = res.data.resData;
                for (let i = 0; i < this.cityList.length; i++) {
                  if (this.cityList[i].text.match(cityReg)) {
                    cityArr.push(this.cityList[i]);
                  }
                }

                if (cityArr.length !== 1) {
                  this.isMsg = true;
                  this.isSuc = false;
                  this.txtMsg = '请填写完整的城市';
                  return;
                }

                this.$axios.get(this.Global.getAllAreaList(cityArr[0].id)).then((areaRes) => {
                  if (!areaRes.data.errorMsg.length) {
                    this.areaList = areaRes.data.resData;
                    for (let i = 0; i < this.areaList.length; i++) {
                      if (this.areaList[i].text.match(areaReg)) {
                        areaArr.push(this.areaList[i]);
                      }
                    }

                   /* if (areaArr.length !== 1) {
                      this.isMsg = true;
                      this.isSuc = false;
                      this.txtMsg = '请填写完整的县（区）';
                      return false;
                    } else { */
                      this.addressObj.addressContent = content;
                      this.addressObj.provinceId = provinceArr[0].id;
                      this.addressObj.provinceName = provinceArr[0].text;
                      this.addressObj.cityId = cityArr[0].id;
                      this.addressObj.cityName = cityArr[0].text;
                      if (areaArr.length === 1) {
                        this.addressObj.areaId = areaArr[0].id;
                        this.addressObj.areaName = areaArr[0].text;
                      }
                    console.log(this.addressObj);
                    this.cancelBtn(true);
                      return true;
                    // }
                  }
                });
              }
            });
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请填写地址';
            return false;
          }
        },

        // 阻止enter换行
        listenCode() {
          if (window.event.keyCode === 13) {
            window.event.preventDefault(); // 组织浏览器默认换行操作
            this.submitBtn();
          }
        },

        // 关闭页面
        closePage() {
          if (this.showType === 'intelligentAddressEntry') {
            this.cancelBtn(false);
          }
        },

        // 提交按钮
        submitBtn() {
          // alert('你已点击提交按钮');
          // this.cancelBtn(true);
          if (this.showType === 'sellerRemarksDel') {
            this.cancelBtn(true);
          } else if (this.showType === 'addGoods') {
            this.cancelBtn(true);
          } else if (this.showType === 'intelligentAddressEntry') {
            if (this.addressObj.addressContent) {
              this.addressObj.addressContent = this.addressObj.addressContent.replace(/[,，]/g, ',');
              if (this.addressObj.addressContent.split(',').length > 3) {
                const content = this.addressObj.addressContent.split(',');
                const contentLen = this.addressObj.addressContent.split(',').length;
                if (contentLen === 4) {
                  if (content[1] && !this.phoneReg(content[1])) {
                    this.isMsg = true;
                    this.isSuc = false;
                    this.txtMsg = '请填写正确的手机号';
                    return;
                  }
                  if (content[2].split(' ').length < 3) {
                    this.isMsg = true;
                    this.isSuc = false;
                    this.txtMsg = '请填写正确的地址格式';
                    return;
                  }
                  if (content[3].length !== 6) {
                    this.isMsg = true;
                    this.isSuc = false;
                    this.txtMsg = '请填写正确的邮编';
                    return;
                  }
                  this.addressObj.name = content[0];
                  this.addressObj.phone = content[1];
                  this.addressObj.postCode = content[3];
                  this.addressResolution(content[2]);
                } else {
                  if (content[1] && !this.phoneReg(content[1])) {
                    this.isMsg = true;
                    this.isSuc = false;
                    this.txtMsg = '请填写正确的手机号';
                    return;
                  }
                  if (content[3].split(' ').length < 3) {
                    this.isMsg = true;
                    this.isSuc = false;
                    this.txtMsg = '请填写正确的地址格式';
                    return;
                  }
                  if (content[4].length !== 6) {
                    this.isMsg = true;
                    this.isSuc = false;
                    this.txtMsg = '请填写正确的邮编';
                    return;
                  }
                  this.addressObj.name = content[0];
                  this.addressObj.phone = content[1];
                  this.addressObj.postCode = content[4];
                  this.addressResolution(content[3]);
                }
              } else if (this.addressObj.addressContent.split(',').length === 3) {
                const content = this.addressObj.addressContent.split(',');
                if (content[1] && !this.phoneReg(content[1])) {
                  this.isMsg = true;
                  this.isSuc = false;
                  this.txtMsg = '请填写正确的手机号';
                  return;
                }
                if (content[2].split(' ').length < 3) {
                  this.isMsg = true;
                  this.isSuc = false;
                  this.txtMsg = '请填写正确的地址格式';
                  return;
                }
                this.addressResolution(content[2]);
                this.addressObj.name = content[0];
                this.addressObj.phone = content[1];
              } else {
                this.isMsg = true;
                this.isSuc = false;
                this.txtMsg = '请填写地址';
              }
             /* const findNum = (this.addressObj.addressContent.split(' ')).length - 1; // 空格出现的次数
              const addressIndex = this.addressObj.addressContent.indexOf(' ');
              const name = this.addressObj.addressContent.substring(addressIndex + 1, this.addressObj.addressContent.lastIndexOf(' '));
              const phone = this.addressObj.addressContent.substring(this.addressObj.addressContent.lastIndexOf(' ') + 1);
              this.addressObj.name = name;
              this.addressObj.phone = phone;
              const reg = /.+?(省|市|自治区|自治州|县|区|盟|旗)/g;
              if (this.addressObj.addressContent.indexOf(' ') === this.addressObj.addressContent.lastIndexOf(' ') || findNum > 2) {
                this.isMsg = true;
                this.isSuc = false;
                this.txtMsg = '地址无法解析，请核对填写格式是否正确';
              } else {
                const address = this.addressObj.addressContent.substring(0, addressIndex + 1).match(reg);
                if (!address) {
                  this.isMsg = true;
                  this.isSuc = false;
                  this.txtMsg = '请填写正确的地址';
                } else if (!this.phoneReg(phone) && !this.telephone(phone)) {
                  this.isMsg = true;
                  this.isSuc = false;
                  this.txtMsg = '请输入正确的联系电话';
                  // this.txtMsg = '现在只支持中国大陆加港澳台的手机号，请输入正确的联系电话';
                } else if (address.length < 2) { // 判断省市区的数组长度
                  this.isMsg = true;
                  this.isSuc = false;
                  this.txtMsg = '请填写正确的地址';
                } else {
                  if (this.addressObj.addressContent.substring(0, 2) === '海外') {
                    this.addressObj.provinceName = '海外';
                    this.addressObj.cityName = '海外';
                    this.addressObj.areaName = '海外';
                  } else if (this.addressObj.addressContent.substring(0, 2) === '北京') {
                    this.specialProvince(address, '北京');
                  } else if (this.addressObj.addressContent.substring(0, 2) === '上海') {
                    this.specialProvince(address, '上海');
                  } else if (this.addressObj.addressContent.substring(0, 2) === '天津') {
                    this.specialProvince(address, '天津');
                  } else if (this.addressObj.addressContent.substring(0, 2) === '重庆') {
                    this.specialProvince(address, '重庆');
                  } else if (this.addressObj.addressContent.substring(0, 2) === '台湾') {
                    this.specialProvince(address, '台湾');
                  } else {
                    this.addressObj.provinceName = address[0];
                    this.addressObj.cityName = address[1];
                    if ((address[2])) {
                      this.addressObj.areaName = address[2];
                      this.addressObj.addressName = this.addressObj.addressContent.substring(this.addressObj.addressContent.indexOf(this.addressObj.areaName) +
                        this.addressObj.areaName.length, this.addressObj.addressContent.indexOf(' '));
                      this.cancelBtn(true);
                    } else {
                      this.isMsg = true;
                      this.isSuc = false;
                      this.txtMsg = '请填写完整的正确地址';
                    }
                  }
                  // this.cancelBtn(true);
                }
              } */
              console.log(this.addressObj);
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = '请填写地址';
            }
          }
        },

        // 取消按钮
        cancelBtn(type) {
          this.$emit('cancelbtn', {isShow: false, showType: this.showType, handleType: type, orderMsg: this.orderMsg, address: this.addressObj});
        },

        // 接收提示框传送的数据
        closeMsgDialog(e) {
          this.isMsg = e;
        }
      },
      created() {
        console.log(this.orderMsg);
        if (this.showType === 'intelligentAddressEntry') {
          this.addressObj.addressContent = this.orderMsg;
          this.getAllProvinceList();
        }
      }
    }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .order_list_embed_msg_embed {
    background-color: #fff;

    &.intelligent_address_entry {
      z-index: 1;

      textarea {
        width: 500px;
        height: 75px;
        margin: 25px;
      }
    }

    /*改货-SKU校验失败*/
    .validatuion_failed {

      .table {
        margin: 0 auto;

        thead, tbody tr {
          display: table;
          width: 100%;
          table-layout: fixed;

          th, td {
            padding: 10px;
          }
        }

        tbody {
          display: block;
          width: 100%;
          max-height: 440px;
          overflow-y: auto;
        }
      }
    }

    /*改货—库存不足数据*/
    .insufficient_inventory {

      .table {
        margin: 0 auto;

        thead, tbody tr {
          display: table;
          width: 100%;
          table-layout: fixed;

          th, td {
            padding: 10px;
          }
        }

        tbody {
          display: block;
          width: 100%;
          max-height: 440px;
          overflow-y: auto;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/sales-management/order-list-embed-msg-embed.vue